import { ErrorLogComponent } from '@cian/error-log-component';
import { UiKitRoot, UiKitToastsContextProvider } from '@cian/ui-kit';
import { PropsWithChildren } from 'react';
import { GetProps, Provider } from 'react-redux';
import { AnyAction } from '@reduxjs/toolkit';

import { IApplicationCommonRootComponentProps } from '../../types/applicationRootComponent';
import { ApplicationContext } from '../../utils/applicationContext';
import { TGenericStoreState } from '../../redux';

const CommonContextProviders: React.FC<PropsWithChildren & IApplicationCommonRootComponentProps> = ({
  context,
  children,
  reduxStore,
}) => {
  return (
    <ErrorLogComponent logger={context.logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitRoot deviceType={context.custom.initialDeviceType}>
          <UiKitToastsContextProvider>
            <Provider<AnyAction, TGenericStoreState> store={reduxStore}>{children}</Provider>
          </UiKitToastsContextProvider>
        </UiKitRoot>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};

/** HOC для объединения всех общих провайдеров в один компонент. */
export const withCommonProviders = (Component: React.FC<GetProps<typeof CommonContextProviders>>) => {
  const App: React.FC<GetProps<typeof CommonContextProviders>> = props => (
    <CommonContextProviders {...props}>
      <Component {...props} />
    </CommonContextProviders>
  );

  return App;
};
